import useSwr from 'swr'

export const useInstructorsByCategory = (numInstructors, category) => {
  const { data, error } = useSwr(
    `/jsonapi/v1/courses?filter[category]=${category}&page[limit]=${numInstructors}`,
  )

  return {
    instructorsByCategory: data,
    error,
  }
}
